RivalIQ.module('collections', function (collections, App, Backbone, Marionette, $, _) {

    'use strict';

    collections.Tokens = Backbone.Collection.extend({

        model: RivalIQ.models.Token,

        url: function () {
            const me = this;
            return `/api/account/tokens/${me.channel}`;
        },

        _tokenExists: function (method) {
            const me = this;
            return me.some(function (token) {
                return _.result(token, method, false);
            });
        },

        tokenWithFbInsightsExists: function () {
            const me = this;
            return me._tokenExists('hasFbInsights');
        },

        tokenWithFbAdsReadExists: function () {
            const me = this;
            return me._tokenExists('hasFbAdsRead');
        },

        tokenWithInstagramInsightsExists: function () {
            const me = this;
            return me._tokenExists('hasInstagramInsights');
        }
    });

});
